"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionsDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.InteractionsDefinition = (0, static_service_1.defineStaticService)('viewer-core/interactions');
//# sourceMappingURL=index.js.map